





































































import Vue from 'vue';
import { mapState } from 'vuex';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import pxCard from '@/dex-shared/components/px-card.vue';

export default Vue.extend({
  components: {
    pxCard,
    SquareEditOutlineIcon,
  },
  computed: {
    ...mapState({
      boardSubsection: (state: any) => state.boardSubsections.board_subsection,
    }),
  },
  async created() {
    let boardSubsectionId = parseInt(this.$route.params.boardSubsectionId);
    if (!boardSubsectionId) boardSubsectionId = 1; // TODO: redirect to index
    this.$store.dispatch('PULL_BOARD_SUBSECTION', boardSubsectionId);
  },
});
